import { Button, Container, Stack, Typography } from '@mui/material';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', py: 4 }}>
      <Stack spacing={2} alignItems="center" textAlign="center">
        <Typography variant="overline" color="primary.main" sx={{ letterSpacing: 1.6 }}>
          Page not found
        </Typography>
        <Typography variant="h3">The requested screen is not available in this workspace.</Typography>
        <Typography variant="body1" color="text.secondary">
          Return to the dashboard or use the sidebar navigation to continue using Varibox Control Center.
        </Typography>
        <Button variant="contained" startIcon={<HomeRoundedIcon />} onClick={() => navigate('/dashboard')}>
          Go to dashboard
        </Button>
      </Stack>
    </Container>
  );
}